import { useCallback } from 'react'
import { formatBlockchainCurrency, formatCurrency } from '@/utils/format'
import { useTokenDecimals } from './token/use-token-decimals'
import { useTokenSymbol } from './token/use-token-symbol'
import { SupportedCurrencies } from '@portafino/shared'

/**
 * Return predefined formatters to be used for currency amounts
 * Default currency is USD, since we are locked to USDC
 * If we will support other currencies, we will need to pass the currency as a prop
 * @returns
 */
export default function useCurrencyFormats(currency = SupportedCurrencies.USD) {
  const { decimals = 6 } = useTokenDecimals()
  const { data: symbol } = useTokenSymbol()

  const formatAmount = useCallback(
    (amount: number) => {
      return formatCurrency(amount, currency.toUpperCase())
    },
    [currency],
  )

  const formatBlockchainAmount = useCallback(
    (amount: number) => {
      return formatBlockchainCurrency(amount, symbol as string, decimals)
    },
    [decimals, symbol],
  )

  return {
    formatAmount,
    formatBlockchainAmount,
  }
}